<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="19"
		viewBox="0 0 24 19"
		fill="none"
	>
		<path
			d="M15.7499 12.167V11.417V7.66706L11.25 3.16708H5.24999C4.85217 3.16708 4.47064 3.32512 4.18934 3.60642C3.90803 3.88772 3.75 4.26925 3.75 4.66707V16.667C3.75 17.0648 3.90803 17.4464 4.18934 17.7277C4.47064 18.009 4.85217 18.167 5.24999 18.167H14.2499C14.6478 18.167 15.0293 18.009 15.3106 17.7277C15.5919 17.4464 15.7499 17.0648 15.7499 16.667V16.466"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.2499 3.16708V7.66706H15.7499"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.74998 15.7499H2.24999C1.85217 15.7499 1.47064 15.5919 1.18934 15.3106C0.908034 15.0293 0.75 14.6477 0.75 14.2499V2.24999C0.75 1.85217 0.908034 1.47064 1.18934 1.18934C1.47064 0.908034 1.85217 0.75 2.24999 0.75H8.24996L10.25 2.9585"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.7497 11.417H6.74976"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.1247 14.4169H6.74976"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.24975 8.41692H7.49975H6.74976"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.0978 18.0123L22.8478 14.2623L19.0978 10.5123"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M22.8478 14.2623H13.8479"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'ExportAndCopyIcon',
}
</script>
